<div *ngIf="isFilePreviewAreaVisible()" class="leftBorder file-preview-wrapper">
  <div class="header-wrapper preview-header-bar-redesign">
    <div class="display-table-cell middle fixed top-buffer-sm preview-file-name h5 strong redesign">
      <div class="display-flex preview-header">
        <div class="device-logs redesign">{{ activitytype }}</div>
        <span *ngIf="activitytype" class="separator"></span>
        <div [hidden]="!isActivityIcon" class="device-icon">
          <span class="hd-icon middle overlap icon-lg hd-icon-phone"></span>
          <span class="hd-icon middle overlap hd-icon-phonescreen icon-lg online"></span>
        </div>
        <div class="title">
          <div class="device-name redesign" sa-ellipsis placement="bottom" [fullText]="displayName">
          </div>
          <span
            [ngClass]="{ 'work-panel-redesign': false }"
            class="file-preview-download hd-icon icon-md hd-icon-download"
            (click)="download()"
          ></span>
        </div>
        <span class="spacer"></span>
        <div class="activity-creation-date" *ngIf="isADBLogActivity">
          <span class="activity-updating-time-regular subtext-gray">{{
            getActivityDateTime() | date : "MMM d, y 'at' h:mm a"
          }}</span>
        </div>
        <span class="preview-title-bar-button">
          <div class="hd-icon hd-icon-close icon-md preview-title-bar-button-icon" (click)="closePreview()"></div>
        </span>
      </div>
    </div>
  </div>

  <div
    class="display-flex"
    [ngClass]="{ 'display-flex content-aligned-right': !showSearchBarToggle() }"
    *ngIf="isADBLogActivity || isLog()"
  >
    <div class="flex-div" *ngIf="showSearchBarToggle()">
      <div *ngIf="(!isLoading && isLog()) || !isActivityIcon" class="search-space">
        <div class="search-icon fa fa-search fa-flip-horizontal"></div>
        <app-text-input
          class="search-input"
          id="searchInputId"
          [type]="'text'"
          [autocomplete]="'off'"
          [spellcheck]="false"
          [placeholder]="'licenceExpiration_Action_Button' | xsI18n"
          [ngModel]="searchInputText"
          (change)="onChangePerformSearch()"
        >
        </app-text-input>
        <div
          class="cancel-search-button"
          *ngIf="searchInputText != ''"
          [ngClass]="{ 'width-adjustment': matchSearchedResults.length > 0 }"
          (click)="clearSearchInputText()"
        >
          <span class="hd-icon hd-icon-close icon-sm icon-position"> </span>
        </div>
        <div
          class="hd-icon hd-icon-dropdown icon-sm up-and-down-button line-right-border rotate-up-side-down"
          *ngIf="searchInputText != '' && matchSearchedResults.length > 0"
          (click)="higlighthtSearch('up')"
        ></div>
        <div
          class="hd-icon hd-icon-dropdown icon-sm up-and-down-button line-left-border"
          *ngIf="searchInputText != '' && matchSearchedResults.length > 0"
          (click)="higlighthtSearch('down')"
        ></div>
      </div>
    </div>
    <div *ngIf="isActivityIcon" class="flex-div">
      <div class="file-selection-space">
        <div class="file-selection">
          <soti-select
            [(ngModel)]="activity.fileName"
            class="dropdown-list-custom"
            panelClass="file-dropdown-container"
          >
            <soti-option
              class="dropdown-option"
              *ngFor="let options of fileList; let i = index"
              [value]="options.caption"
              (selection)="onClickSelectFile(i)"
              >{{ options.caption }}
            </soti-option>
          </soti-select>
        </div>
      </div>
    </div>
  </div>
  <div id="preview-area-id" class="preview-area">
    <span
      [ngClass]="{ 'preview-image-spacer': isMedia(), 'preview-editor-spacer': isLog() }"
      [hidden]="isError()"
    ></span>
    <xs-attachment-media
      [imageSrc]="isImage() ? previewUrl : ''"
      [videoSrc]="isVideo() ? previewUrl : ''"
      mediaClass="preview-image"
      [activity]="activity"
    ></xs-attachment-media>
    <quill-editor
      id="richtexteditorId"
      [hidden]="isLoading || isError()"
      *ngIf="isPreviewableLog()"
      content="logFileData"
      [ngClass]="{ 'is-loaded': !isLoading }"
      [readOnly]="true"
      (onEditorCreated)="quillEditorReady($event)"
      (onEditorChanged)="quillEditorUpdate()"
      [modules]="{ toolbar: false }"
    ></quill-editor>
    <div class="overlay" *ngIf="(isLoadingRemaingtext || isLoading) && isLog()">
      <div class="admin-spinner remainingtext-loading-status">
        <div class="fa fa-circle-o-notch fa-spin fa-2x middle"></div>
      </div>
    </div>

    <div class="preview-error" *ngIf="isPreviewNotAvailable()" [hidden]="isLoading">
      <img class="preview-error-image" src="{{ filePreviewErrorContent.imageUrl }}" />
      <div class="preview-error-title">{{ filePreviewErrorContent.title }}</div>
      <div class="preview-error-subtitle" *ngFor="let stitle of filePreviewErrorContent.subtitle">
        <span>{{ stitle }}</span>
      </div>
      <button
        type="button"
        *ngIf="filePreviewErrorContent.candownload"
        (click)="download()"
        class="xs-btn btn-primary btn-download-file"
      >
        {{ 'filePreview_Preview_Not_Available_DownloadButton' | xsI18n }}
      </button>
    </div>
  </div>
</div>
